var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _rect2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _circle, _path48, _path49, _line, _circle2, _path50, _circle3, _circle4, _line2, _polyline, _polyline2, _polyline3, _circle5, _circle6, _path51, _path52, _circle7, _path53, _circle8, _line3, _line4, _line5, _line6, _circle9, _line7, _line8, _line9, _line10, _path54, _path55, _path56, _rect3, _rect4, _rect5, _rect6, _rect7, _polyline4, _polyline5, _circle10, _path57, _path58, _circle11, _ellipse, _circle12, _path59, _line11, _circle13, _circle14, _circle15, _circle16, _circle17, _line12, _circle18, _polygon, _path60, _circle19, _circle20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArgument01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    viewBox: "0 0 184.44 133.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3b566e;}.cls-2{fill:#293f52;}.cls-3{fill:#ffd5a2;}.cls-4{fill:#00aab6;}.cls-5{fill:#007d87;}.cls-6{fill:#fdbe83;}.cls-7{fill:#ec6e00;}.cls-8{fill:#ff8700;}.cls-9{fill:#ffaa81;}.cls-10{fill:#f2ad6b;}.cls-11{fill:#243849;}.cls-12{fill:#2c4357;}.cls-13{fill:#fff;}.cls-14{fill:#d85624;}.cls-15{fill:#ff7734;}.cls-16{fill:#f9c495;}.cls-17{fill:#ffedd6;}.cls-18,.cls-19,.cls-20{fill:none;}.cls-18,.cls-20{stroke:#3b566e;}.cls-18,.cls-19{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-19{stroke:#00aab6;}.cls-20{stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.42,133.35a27.55,27.55,0,0,1,2.48-5.18,27.55,27.55,0,0,1,2.48,5.18h13.11a161.46,161.46,0,0,0,1.43-19h-34a159.1,159.1,0,0,0,1.42,19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.89,114.31c0,1.86.1,4,.23,6.39,3,1.82,8.83,4.32,18.65,4.32a40.81,40.81,0,0,0,14.81-2.44c.19-3.08.29-5.93.34-8.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.93,53.56c-7,10.09-22.21,18.07-26.86,19.44a31.48,31.48,0,0,1,1.43,3c.7,1.64,2.13,4.51,2.88,6.13,17.68-6.79,27.88-24.68,27.88-24.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.94,72S64.56,63.1,63.24,57.59c-.8-3.32.9-16.71.9-16.71l-6.54-.35s-4.14,16.89-1.39,22.82c3.46,7.46,19.13,19.27,19.13,19.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.9,121.36c15.41,0,20-5.27,20-5.27-5.27-12.87-5-27.67-5-27.67,6.29-2.25,14.84-5.38,14.84-5.38-1.57-6.52-8.34-14.48-8.34-14.48-8.94,3.41-14.46,5-14.46,5L91.9,70.09,85,73.32s-3.4.58-12-7.18a42.91,42.91,0,0,0-8.25,11.19S72.31,85,77.13,88.1c0,0,.78,15.56-4.5,28.44C72.63,116.54,76.49,121.36,91.9,121.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85,73.32h0a4,4,0,0,1-1.3-.17h0L83.22,73a2.63,2.63,0,0,0-.55,1.57c0,2.55,4.2,4.61,9.38,4.61s9.39-2.06,9.39-4.61a5.85,5.85,0,0,0-.32-1.72L99,73.53,91.9,70.09,85,73.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.9,66.12l2.68-1A1.73,1.73,0,0,1,97,66.46c0,2.25.38,5.58,2.14,7.42A1.35,1.35,0,0,1,98.81,76a13.53,13.53,0,0,1-6.91,1.54h0A13.61,13.61,0,0,1,85,76.06a1.37,1.37,0,0,1-.4-2.19c1.76-1.83,2.12-5.16,2.14-7.41a1.73,1.73,0,0,1,2.44-1.35l2.68,1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97,66.46a1.73,1.73,0,0,0-2.44-1.35l-2.68,1h0l-2.68-1a1.73,1.73,0,0,0-2.44,1.35,20.73,20.73,0,0,1-.2,2.71A17.93,17.93,0,0,0,94.45,71h0a18.59,18.59,0,0,0,3.09-.26A17.45,17.45,0,0,1,97,66.46Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.6,55.77h0a3.5,3.5,0,0,1-3.48-3.48V49.43A3.5,3.5,0,0,1,79.6,46h0a3.49,3.49,0,0,1,3.47,3.48v2.86A3.49,3.49,0,0,1,79.6,55.77Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.27,55.77h0a3.5,3.5,0,0,1-3.48-3.48V49.43A3.5,3.5,0,0,1,104.27,46h0a3.49,3.49,0,0,1,3.47,3.48v2.86A3.49,3.49,0,0,1,104.27,55.77Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.9,68.56h0A14.25,14.25,0,0,1,77.69,54.35v-10A14.25,14.25,0,0,1,91.9,30.15h0a14.25,14.25,0,0,1,14.21,14.2v10A14.25,14.25,0,0,1,91.9,68.56Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.16,32.93c1.52,3-1.9,11.18-1.9,11.18S74.73,35,80.16,32.93Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104.73,33.43s3.91,1.87,2.73,11.44C107.46,44.87,100.93,39.23,104.73,33.43Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M81,41.11s-1.6-6-.8-8.18,3-6.24,10-5.3,14.19-.44,15-3.2c0,0,4.75,6.83-1.36,16Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.68,55.63H82.24a2.81,2.81,0,0,1-2.8-2.8h0A2.81,2.81,0,0,1,82.24,50h1.44a2.81,2.81,0,0,1,2.81,2.81h0A2.81,2.81,0,0,1,83.68,55.63Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M101.56,55.63h-1.44a2.82,2.82,0,0,1-2.81-2.8h0A2.82,2.82,0,0,1,100.12,50h1.44a2.81,2.81,0,0,1,2.8,2.81h0A2.81,2.81,0,0,1,101.56,55.63Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M91.9,56.24h0a2.72,2.72,0,0,1-2.71-2.71V50a2.72,2.72,0,0,1,2.71-2.71h0A2.72,2.72,0,0,1,94.61,50v3.57A2.72,2.72,0,0,1,91.9,56.24Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.81,
    y: 37.01,
    width: 34.17,
    height: 15.81,
    rx: 6.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 76.14,
    y: 38.52,
    width: 31.53,
    height: 12.81,
    rx: 5.47
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M88.45,38.52H81.21a5.08,5.08,0,0,0-5.07,5.07v2.66a5,5,0,0,0,1.25,3.32Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M107.24,41.56a5.15,5.15,0,0,0-2.9-2.73Q98.09,45.1,91.8,51.32h5.68Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.21,51.32h.38a5.09,5.09,0,0,0,5.08-5.07v-.39Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M96.92,38.52H93.18L80.43,51.26a5,5,0,0,0,.78.06h2.91Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M105.13,43.87a1,1,0,1,1-1-1A1,1,0,0,1,105.13,43.87Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M104.48,43.87a.36.36,0,1,1-.36-.36A.36.36,0,0,1,104.48,43.87Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M104.48,46.45a.36.36,0,1,1-.36-.36A.36.36,0,0,1,104.48,46.45Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M98.17,57.83a.7.7,0,0,1,.69.76,7,7,0,0,1-13.92,0,.7.7,0,0,1,.69-.76Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M91.9,60.82a10,10,0,0,0-5.35,1.52,7,7,0,0,0,10.7,0A10,10,0,0,0,91.9,60.82Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M87.29,63.1a7,7,0,0,0,9.22,0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M98.66,59.62a7,7,0,0,0,.2-1,.7.7,0,0,0-.69-.76H85.63a.7.7,0,0,0-.69.76,7,7,0,0,0,.2,1Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.73,83.78l2-.74h0c-.06-.27-.14-.55-.22-.83,0-.07-.05-.14-.07-.2-.08-.28-.18-.56-.28-.83h0q-.15-.42-.33-.84l-.08-.21c-.12-.28-.24-.56-.37-.84l-.3-.63c-.14-.28-.28-.56-.43-.83a2.12,2.12,0,0,0-.11-.21c-.14-.28-.29-.55-.44-.82h0c-.15-.27-.31-.54-.47-.8l-.11-.2q-.24-.41-.48-.78c-.23-.38-.47-.76-.71-1.12l-.48-.71-.12-.17c-.15-.23-.31-.45-.46-.67l-.33-.47-.9-1.22-.07-.09-.22-.29,0,0-.23-.3,0-.07-.18-.22,0,0-.19-.23,0-.06-.14-.16,0,0-.14-.17,0,0-.1-.12,0,0-.08-.1h0l0,0h0l0,0-1.48.56C114.33,72.93,118.21,78.49,119.73,83.78Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.31,78.88a32.48,32.48,0,0,1,8.21-11.41l-.75-.64L73,66.14a42.91,42.91,0,0,0-8.25,11.19Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66,23.92h0a1.42,1.42,0,0,1,1.32,1.5l-.75,10.9a1.43,1.43,0,0,1-1.51,1.32h0a1.43,1.43,0,0,1-1.32-1.51l.75-10.9A1.41,1.41,0,0,1,66,23.92Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.18,33.59h2.09a6.23,6.23,0,0,1,6.23,6.23v1.48a2.41,2.41,0,0,1-2.41,2.41h-6.5a2.41,2.41,0,0,1-2.41-2.41V36.6A3,3,0,0,1,58.18,33.59Z",
    transform: "translate(120.37 79.24) rotate(-178.14)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.34,33.57h0a1.07,1.07,0,0,1,.87,1.23l-.76,4.31a1.42,1.42,0,0,1-1.65,1.15h0a1.42,1.42,0,0,1-1.15-1.65L67.26,35A1.8,1.8,0,0,1,69.34,33.57Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69,38.47h0A1.08,1.08,0,0,1,69,40l-3.25,3.26a1.52,1.52,0,0,1-2.07.16h0A2,2,0,0,1,63.74,41l2.74-2.57A1.8,1.8,0,0,1,69,38.47Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.54,39a4.14,4.14,0,0,1,2.9,1.24l0,1.51a2.12,2.12,0,0,1-2.18,2l-4-.12A2.72,2.72,0,0,1,59.66,42C59.72,40.27,61.45,39,63.54,39Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M62.5,30.78h0a1.47,1.47,0,0,1,1.36,1.56l-.15,4.79a1.47,1.47,0,0,1-1.46,1.46h0A1.46,1.46,0,0,1,60.88,37l.15-4.8A1.48,1.48,0,0,1,62.5,30.78Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M59.66,31h0A1.47,1.47,0,0,1,61,32.53l-.16,4.79a1.48,1.48,0,0,1-1.46,1.47h0A1.48,1.48,0,0,1,58,37.23l.15-4.79A1.47,1.47,0,0,1,59.66,31Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M56.81,31.48h0a1.42,1.42,0,0,1,1.37,1.46L58,37.43a1.42,1.42,0,0,1-1.46,1.37h0a1.43,1.43,0,0,1-1.37-1.46l.15-4.49A1.41,1.41,0,0,1,56.81,31.48Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.24,40.56h0a1.25,1.25,0,0,0-1.32,1.16l-.65,9.56a1.24,1.24,0,0,0,1.15,1.32h0a1.23,1.23,0,0,0,1.32-1.15l.66-9.56A1.26,1.26,0,0,0,134.24,40.56Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.88,42h0a1.24,1.24,0,0,0-1.5.92l-2.22,9.32a1.25,1.25,0,0,0,.92,1.5h0a1.26,1.26,0,0,0,1.5-.92l2.22-9.33A1.24,1.24,0,0,0,140.88,42Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.76,44.09h0a1.24,1.24,0,0,0-1.6.7l-3.5,8.93a1.26,1.26,0,0,0,.71,1.61h0a1.25,1.25,0,0,0,1.61-.71l3.49-8.92A1.24,1.24,0,0,0,143.76,44.09Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.57,40.34h0a1.29,1.29,0,0,0-1.4,1.15L135,49.8a1.29,1.29,0,0,0,1.06,1.48h0a1.3,1.3,0,0,0,1.41-1.15l1.15-8.31A1.29,1.29,0,0,0,137.57,40.34Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.81,49.77h5.71a2.12,2.12,0,0,1,2.12,2.12v1.29a5.46,5.46,0,0,1-5.46,5.46h-1.83A2.65,2.65,0,0,1,131.7,56V51.88a2.12,2.12,0,0,1,2.12-2.12Z",
    transform: "translate(13.04 -25.38) rotate(11.14)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.37,49.05h0a.94.94,0,0,0-.71,1.11l.82,3.75a1.25,1.25,0,0,0,1.49,1h0a1.25,1.25,0,0,0,.95-1.49l-.69-3.12A1.57,1.57,0,0,0,128.37,49.05Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.84,53.33h0a1,1,0,0,0,.09,1.33l3,2.74a1.31,1.31,0,0,0,1.81.06h0a1.76,1.76,0,0,0-.16-2.14l-2.5-2.15A1.58,1.58,0,0,0,128.84,53.33Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.27,54a3.64,3.64,0,0,0-2.72.49l-.26,1.3A1.85,1.85,0,0,0,132.75,58l3.42.68a2.29,2.29,0,0,0,.83-1.36C137.29,55.81,136.07,54.35,134.27,54Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M57.5,37.32a.81.81,0,1,1-.81-.81A.81.81,0,0,1,57.5,37.32Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 59.53,
    cy: 37.01,
    r: 0.81
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M63.18,36.91a.81.81,0,1,1-.81-.81A.81.81,0,0,1,63.18,36.91Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M125.09,58a14,14,0,1,1,11.29,5.72"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 136.38,
    y1: 35.73,
    x2: 136.38,
    y2: 16.93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 136.38,
    cy: 11.73,
    r: 5.23,
    transform: "translate(93.83 141.83) rotate(-76.81)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.42,10.43l-.77-.44a1.5,1.5,0,0,0-2.25,1.3v.88a1.5,1.5,0,0,0,2.25,1.3l.77-.44A1.5,1.5,0,0,0,137.42,10.43Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 153.85,
    cy: 19.12,
    r: 6.92,
    transform: "translate(4.18 59.56) rotate(-22.2)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 117.77,
    cy: 21.44,
    r: 6.92,
    transform: "translate(70.08 131.23) rotate(-76.84)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 136.38,
    y1: 63.69,
    x2: 136.38,
    y2: 97.05
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "136.55 85.41 149.32 85.41 151.16 83.57"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "136.38 28.14 144.84 28.14 148.95 24.02"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "136.38 32.26 129.3 32.26 123.01 25.96"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 136.38,
    cy: 107.43,
    r: 10.17
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.38,
    cy: 107.43,
    r: 6.21,
    transform: "translate(0.68 215.73) rotate(-76.82)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.56,108a4.93,4.93,0,0,0,0-.55,6.21,6.21,0,0,0-6.21-6.21v6.21Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.38,107.43l-4.67,4.1A6.2,6.2,0,0,0,142.56,108Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 156.64,
    cy: 74.96,
    r: 10.21,
    transform: "translate(-7.13 132.71) rotate(-45)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.68,74.3l-3.36-5.81a.79.79,0,0,0-1.37,0l-3.36,5.81a.8.8,0,0,0,.69,1.19H155v4.75a1.6,1.6,0,1,0,3.19,0V75.49H160A.8.8,0,0,0,160.68,74.3Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 153.85,
    cy: 19.12,
    r: 3.65
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 153.85,
    y1: 15.47,
    x2: 153.85,
    y2: 14.28
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 153.85,
    y1: 23.96,
    x2: 153.85,
    y2: 22.78
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 157.5,
    y1: 19.12,
    x2: 158.69,
    y2: 19.12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 149.01,
    y1: 19.12,
    x2: 150.19,
    y2: 19.12
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 153.85,
    cy: 19.12,
    r: 2.05
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 153.85,
    y1: 17.07,
    x2: 153.85,
    y2: 16.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 153.85,
    y1: 21.84,
    x2: 153.85,
    y2: 21.17
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 155.9,
    y1: 19.12,
    x2: 156.56,
    y2: 19.12
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 151.13,
    y1: 19.12,
    x2: 151.79,
    y2: 19.12
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.86,49.35a1.51,1.51,0,1,1-1.5-1.5A1.51,1.51,0,0,1,151.86,49.35Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.9,49.35a1.51,1.51,0,1,1-3,0,1.51,1.51,0,0,1,3,0Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.38,36.88a1.51,1.51,0,1,1,1.5-1.51A1.51,1.51,0,0,1,136.38,36.88Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 114.47,
    y: 18.14,
    width: 6.6,
    height: 6.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.38,
    y: 21.17,
    width: 1.08,
    height: 2.78
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 117.4,
    y: 18.82,
    width: 3,
    height: 1.19
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.9,
    y: 20.01,
    width: 1.5,
    height: 1.43
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 117.6,
    y: 22.63,
    width: 1.64,
    height: 1.32
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "60.51 24.43 50.43 24.43 29.16 45.71 29.16 88.97"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "29.16 74.81 43.04 74.81 51.53 83.3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 29.16,
    cy: 100.53,
    r: 11.56,
    transform: "translate(-36.97 19.39) rotate(-23.01)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.75,100l-2.6-4.51a.62.62,0,0,0-1.07,0L21.48,100a.61.61,0,0,0,.53.92h1.37v3.69a1.24,1.24,0,1,0,2.48,0v-3.69h1.36A.61.61,0,0,0,27.75,100Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.56,101.05l2.6,4.51a.62.62,0,0,0,1.07,0l2.6-4.51a.62.62,0,0,0-.53-.93H34.94V96.43a1.24,1.24,0,1,0-2.48,0v3.69H31.09A.62.62,0,0,0,30.56,101.05Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 56.08,
    cy: 87.8,
    r: 6.33
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 56.08,
    cy: 87.8,
    rx: 4.46,
    ry: 2.97
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 56.08,
    cy: 87.8,
    r: 2.25
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M57,87.8a.88.88,0,1,1-.88-.88A.88.88,0,0,1,57,87.8Z"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 29.16,
    y1: 45.71,
    x2: 39.64,
    y2: 56.2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 44.11,
    cy: 60.67,
    r: 6.33
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.11,
    cy: 54.33,
    r: 1.38
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.11,
    cy: 67,
    r: 1.38
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.45,
    cy: 60.67,
    r: 1.38
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.78,
    cy: 60.67,
    r: 1.38
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 43.12,
    y1: 31.75,
    x2: 31.33,
    y2: 19.96
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 29.16,
    cy: 10.42,
    r: 9.73
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "29.16 17.84 33.04 11.61 29.16 12.67 25.27 11.61 29.16 17.84"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M29.16,3.91a5.16,5.16,0,1,0,5.15,5.15A5.16,5.16,0,0,0,29.16,3.91Zm0,7.33a2.18,2.18,0,1,1,2.17-2.18A2.19,2.19,0,0,1,29.16,11.24Z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 66.29,
    cy: 21.84,
    r: 6.33
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 66.29,
    cy: 21.84,
    r: 3.64
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgument01);
export default __webpack_public_path__ + "static/media/argument-01.597f56c78269bb9c2637bd1de73468c7.svg";
export { ForwardRef as ReactComponent };